<template>
  <div>
    <div class="form-row">
      <div class="col">
        <div class="form-group mb-0">
          <label for="select-publish-date">
            <i class="fa fa-calendar mr-2"></i> Data Inizio
          </label>
          <v-date-picker
            ref="from"
            v-model="start"
            :popover="{ placement: 'auto', visibility: 'click' }"
            :input-props="{ class: 'input form-control', placeholder: 'Data inizio', readonly: true}"
            @input="updateIntervals"
          />
        </div>
      </div>
      <div class="col">
        <div class="form-group mb-0">
          <label for="select-publish-date">
            <i class="fa fa-calendar mr-2"></i> Data Fine
          </label>
          <v-date-picker
            ref="to"
            v-model="end"
            :min-date="start"
            :popover="{ placement: 'auto', visibility: 'click' }"
            :input-props="{ class: 'input form-control',    placeholder: 'Data fine',    readonly: true }"
            @input="updateIntervals"
          />
        </div>
      </div>
    </div>
<div class="py-4">
    <week-grid v-model="matrice" @change="updateMatrix"></week-grid>
</div>
    <div class="pb-4">
      <a
        role="button"
        :class="['btn btn-info btn-small collapse-button', customDates? 'collapsed': '']"
        style="color:white;"
        @click="customDates = !customDates"
      >
        Personalizza le date
        <i class="fa fa-chevron-right"></i>
      </a>
      <transition>
      <div v-show="customDates" id="custom-dates" class="form-row mt-2">
        <div class="alert alert-warning my-4 col-12" role="alert">
          Attenzione, la modifica degli intervalli delle date e dei giorni della settimana nei blocchi precedenti sovrascrive la selezione delle date nel blocco sottostante.
        </div>
        <div class="col">
          <v-date-picker
            v-model="dates"
            :columns="$screens({ default: 1, md: 2 })"
            mode="multiple"
            is-expanded
            is-inline
            :disabled-dates= "disabledDates"
            @input="daySelect"
          />
        </div>
      </div>
      </transition>
    </div>

  </div>
</template>
<style lang="scss" scoped>
a.collapse-button {
  font-weight: bold;
  i {
    transition: all 400ms;
    transform: rotate(90deg) !important;
  }
}

a.collapse-button.collapsed i {
  transform: rotate(0deg) !important;
}
</style>
<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import VCalendar from "v-calendar";
import WeekGrid from "./WeekGrid.vue";
import _ from "lodash";

export default {
  components: {
    VueTimepicker,
    VCalendar,
    WeekGrid
  },
  data() {
    return {
      start: new Date(),
      end: new Date(),
      matrice: [0, 0, 0, 0, 0, 0, 0],
      dates: [],
      customDates: false,
      update: false
    };
  },
  props: ["value"],

  watch: {
    value(v2, v1) {
      this.parse();
    }
  },
  computed: {
    disabledDates: function(){

return [];
      let week = [];
      for( var i = 0; i < 7; i++ ){
        if( !this.matrice[i] ){
            week.push( 1 + ( 8 + i ) % 7  );
        }
      }
      if( week.length > 0 ){
        return { weekdays : week }
      }

      return null;
    }
  },
  methods: {
    updateMatrix(value) {
      let self = this;
      if (JSON.stringify(self.matrice) !== JSON.stringify(value)) {
        self.matrice = value;
        self.updateIntervals();
      }
    },
    startUpdate() {
      if (this.update) return false;
      this.update = true;
      return true;
    },
    endUpdate() {
      this.$nextTick(() => {
        this.update = false;
      });
      return true;
    },
    updateIntervals() {
      if( !this.start || !this.end){
        return;
      }
      if (this.startUpdate()) {
        let dates = [];
        var startTime = this.start.getTime(),
          endTime = this.end.getTime();
        for (
          let loopTime = startTime;
          loopTime <= endTime;
          loopTime += 86400000
        ) {
          var loopDay = new Date(loopTime);
          var day = (loopDay.getDay() + 6) % 7;
          if( this.matrice[day] ){
            dates.push(loopDay);
          }
        }
        this.dates = dates;
        this.notify();
        this.endUpdate();
      }
    },
    daySelect() {
      if (this.startUpdate()) {
        if (this.dates.length > 0) {
          this.start = this.dates[0];
          this.end = this.dates[this.dates.length - 1];
        }
        this.notify();
        this.endUpdate();
      }
    },
    parse() {
      if (this.startUpdate()) {
        let v2 = this.value;
        if (v2) {
          let moment = this.$moment;

          this.$set(this, "customDates", v2.customDates, false);
          this.$set(
            this,
            "start",
            this.$moment(v2.start || new Date()).toDate(),
            false
          );
          this.$set(
            this,
            "end",
            this.$moment(v2.end || new Date()).toDate(),
            false
          );

          let matrice = (v2.week || (v2.weekMorning || [0, 0, 0, 0, 0, 0, 0]) );

          this.$set(this, "matrice", matrice, false);

          this.$set(
            this,
            "dates",
            _.map(v2.dates || [], function(item) {
              return moment(item).toDate();
            }),
            false
          );
        }
        this.endUpdate();

        if(v2.weekMorning){
          this.notify();
        }
      }
    },
    notify() {
      let moment = this.$moment;
      let inputValue = {
        dates: _.map(this.dates, function(item) {
          return moment(item).format("YYYY-MM-DD");
        }),
        start: this.$moment(this.start).format("YYYY-MM-DD"),
        end: this.$moment(this.end).format("YYYY-MM-DD"),
        week: this.matrice,       
        customDates: this.customDates
      };
      this.$emit("input", inputValue);
    }
  },
   async mounted() {
    this.parse();
  }
};
</script>
